<script lang="ts">
  import { Popover } from "flowbite-svelte"
  import { fade } from "svelte/transition"
  import { OsmConnection } from "../../Logic/Osm/OsmConnection"
  import { onDestroy } from "svelte"
  import If from "../Base/If.svelte"
  import type { Store } from "../../Logic/UIEventSource"
  import Translations from "../i18n/Translations"
  import Tr from "../Base/Tr.svelte"
  import Avatar from "../Base/Avatar.svelte"

  let open = false
  export let state: {
    osmConnection: OsmConnection
    featureSwitches: { featureSwitchEnableLogin: Store<boolean> }
  }
  let userdetails = state.osmConnection.userDetails
  let username = userdetails.mapD((ud) => ud.name, onDestroy)
  username.addCallbackAndRunD((ud) => {
    if (ud) {
      open = true
      window.setTimeout(() => {
        open = false
      }, 3000)
    }
  })
</script>

<If condition={state.featureSwitches.featureSwitchEnableLogin}>
  <Popover
    class="mt-4 hidden sm:block"
    defaultClass="py-2 px-3 w-fit "
    trigger="null"
    placement="bottom"
    transition={(e) => fade(e, { duration: 150 })}
    bind:open
  >
    {#if $username !== undefined}
      <div style="width: max-content" class="flex items-center">
        <Avatar {userdetails} />
        <div>
          <Tr t={Translations.t.general.welcomeBack} />
          <div class="normal-background" style="width: max-content">
            <b>{$username}</b>
          </div>
        </div>
      </div>
    {/if}
  </Popover>
</If>
